// extracted by mini-css-extract-plugin
module.exports = {"mobileSize":"900","wrapper":"Breadcrumbs-module--wrapper--3W6fS","breadcrumbs":"Breadcrumbs-module--breadcrumbs--3qwVR"};